import * as React from 'react'

/**
 * Whether satellite images should render with the user's saved palette adjustments
 * (custom range and vegetation texture) from the map legend.
 *
 * Off by default: several apps share the map, comparator and note components but only
 * the main app has the legend controls to see and reset an adjustment, so only it
 * provides `true`. Everywhere else images keep the layer's default palette.
 */
const PaletteAdjustmentsContext = React.createContext(false)

export function PaletteAdjustmentsProvider({ enabled = true, children }) {
	return (
		<PaletteAdjustmentsContext.Provider value={enabled}>
			{children}
		</PaletteAdjustmentsContext.Provider>
	)
}

export function usePaletteAdjustmentsEnabled() {
	return React.useContext(PaletteAdjustmentsContext)
}
